import React, { useEffect, useRef, useState } from 'react';
import { FaRegCopy, FaCheck } from 'react-icons/fa';
import { useT } from '../i18n';

const EMAIL = 'hervetusse@gmail.com';

/**
 * Copies the address and says so. The label swaps to "Copied" rather than
 * firing a toast — the confirmation belongs where the action happened.
 */
const CopyEmail = ({ className = '' }) => {
  const t = useT();
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
    } catch {
      // Clipboard is unavailable over plain http and in some browsers; fall
      // back to a selection the reader can copy by hand.
      const input = document.createElement('input');
      input.value = EMAIL;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
    }
    setCopied(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), 1800);
  };

  return (
    <button
      type="button"
      className={`copy-email ${copied ? 'is-copied' : ''} ${className}`}
      onClick={copy}
      aria-label={copied ? t('a11y.emailCopied') : t('a11y.copyEmail')}
    >
      {copied ? <FaCheck aria-hidden="true" /> : <FaRegCopy aria-hidden="true" />}
      <span>{copied ? t('copyEmail.copied') : t('copyEmail.copy')}</span>
    </button>
  );
};

export default CopyEmail;
